import { useMutation } from "@tanstack/react-query";
import { deactivateKlaviyo } from "../../api/bKlaviyoApi";

export const useDeactivateKlaviyo = () => {
  return useMutation({
    mutationKey: ["deactivate-klaviyo"],
    mutationFn: (data) => deactivateKlaviyo(data),
    onError: (error) => {
      console.error("Klaviyo deactivation error:", error.response || error);
    },
  });
};
